import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.styl';
import { resolveStyles } from 'core/utils/styles';

const styleResolver = resolveStyles(styles);

const modifiers = ['left', 'right', 'center'];

/**
 * Компонент, используемый для позиционирования содержимого по горизонтали.
 * Для реализации используется свойство `justify-content`.
 */
export default function GridPosition(props) {
  return (
    <div className={styleResolver([
      'position',
      ...modifiers.map(name => props[name] && `position--${name}`),
    ])}
    >
      {props.children}
    </div>
  );
}

GridPosition.propTypes = {
  /**
   * Позиционирует контент по центру.
   */
  center: PropTypes.bool,
  /** @ignore */
  children: PropTypes.node,

  /**
   * Позиционирует контент по левому краю.
   */
  left: PropTypes.bool,

  /**
   * Позиционирует контент по правому краю.
   */
  right: PropTypes.bool,
};

export { GridPosition as StorybookComponent };
